/**
 * The canonical id vocabulary (`<prefix>:<uuid>`), extracted from index.ts so
 * sibling modules (outcome.ts) can VALUE-import it without creating an ESM
 * evaluation cycle through the barrel — the same role tenancy.ts plays for the
 * tenancy primitives.
 *
 * Every canonical id in the product shares one uuid body, so tightening it
 * (version digits, case) happens here and nowhere else; provider ids
 * (`file_*`, `skill_*`) can never match by construction (§2.8).
 */
const CANONICAL_UUID_SEGMENT = "[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}";
/** Anchored, case-insensitive matcher for one canonical id kind. */
export function canonicalIdPattern(prefix) {
    return new RegExp(`^${prefix}:${CANONICAL_UUID_SEGMENT}$`, "i");
}
//# sourceMappingURL=canonical-ids.js.map